import { BrowserRouter as Router, Route } from 'react-router-dom'
import useEditor from './useEditor';
import Login from './components/Login/Login';
import Header from './components/Header'
import Content from './components/Content'
import Control from './components/Control'
import useLanguage from './useLanguage'
import {useState, useEffect} from 'react'



const App = () => {
  const { editor, setEditor } = useEditor();
  const {language, setLanguage} = useLanguage()//useState({value: 'DA', label: 'DA'})
  const languages = [{value: 'DA', label: 'DA'},{value: 'EN', label: 'EN' }]
  const [breadcrumbObject, setBreadcrumbObject] = useState({type:'', name:'start', link: '', linkText: ''})
  const [editorProfile, setEditorProfile] = useState()

  useEffect(() => {
    const getData = async () => {
      const data = await fetchData()
      global.config.Profile = data.editor.profile
      setEditorProfile(data.editor.profile)
    }

    getData()
  },[breadcrumbObject])

  const fetchData = async () => {

    var graphql = JSON.stringify({
        query: `query ($id: Long){
                    
                    editor(id: $id){
                        id

                        profile{
                            id
                            profileName
                            solutionId
                            isReadonly
                            hasAccessToSettings
                            hasAccessToModels
                            hasAccessToProfiles

                            access{
                              accessCreate
                              accessDraft
                              accessPublish
                              accessDelete
                              contentModelId
                            }
                        }
                    }
                }`,
        variables: {
            "id": global.config.Editor.id
        }
      })
    const res = await fetch(global.config.GraphQL.url + global.config.Editor.publicToken ,{
        method:'POST',
        headers:{
            'Authorization':'Basic ' + global.config.Editor.authToken
            ,'Content-Type': 'application/json'
        },
        body: graphql
    })
    .then(response => response.text())
    .then(result => {return JSON.parse(result).data})
    .catch(error => console.log('error', error))
    const data = await res
    return data
}

  if(!editor) {
    return <Login setEditor={setEditor} />
  }
  if(!language){
    setLanguage({value: 'DA', label: 'DA'})
  }

  
   
  return (
    <div id="cc_container">
      <Router>
        <Route path="/" render={()=>(<Header language={language} languages={languages} onLanguageChange={setLanguage} breadcrumbObject={breadcrumbObject} editorProfile={editorProfile}/>)} />
        <Route path="/" exact strict render={()=> breadcrumbObject.name !== '' && setBreadcrumbObject({name:'', link: '', linkText: ''})}/>
        <div id="cc_area">
            <Route path="/content">
              <Content language={language} setBreadcrumbObject={setBreadcrumbObject} />
            </Route>
            <Route path="/control">
              <Control language={language} setBreadcrumbObject={setBreadcrumbObject}/>
            </Route> 
        </div>
      </Router>
    </div>
  )
}

export default App

